<template>
  <div class="container">
    <div class="head">
      <div class="title">
        <div class="text">投诉办结率24小时未达95%</div>
        <div  class="right-five-txt">
          <div v-if="Number(detail.deduction)==0" class="no-de">未扣分</div>
          <div v-else class="branch">-{{detail.deduction}}</div>
          <div class="timememo"  v-if="isExceed == 1 ">已达扣分上限</div>
        </div>
        
      </div>
      <!-- <div class="tag-box">
        <txtTag
          class="tag"
          :bgColor="'#fff'"
          :border="'#36B374'"
          :txtColor="'#36B374'"
        >{{detail.areaName}}</txtTag>
        <txtTag
          class="tag"
          :bgColor="'#fff'"
          :border="'#36B374'"
          :txtColor="'#36B374'"
        >{{detail.areaType == '1' ? '一': '二'}}类地区</txtTag>
      </div> -->
      <div class="date mt-8">{{ detail.areaName }} {{detail.quarterCN}}</div>
    </div>

    <div class="pg-pd12">
      <!-- 扣分原因 -->
      <!-- <template>
        <causeDeduction :causeContent="detail.deductionReason" causeTitle="扣分原因"></causeDeduction>
      </template> -->
      <div class=" mt-24 mb-12   flex flex-row gap-4 items-end">
        <div class="text-[#333333] text-16 font-bold">考评信息</div>
        <van-popover v-model="showPopover" trigger="click" theme="dark" placement="bottom-start" :offset="[-10, 16]">
          <div class="text-12 px-8 py-12  min-w-60 text-[#e4e3e3]" >
            扣分规则：区域24小时办结率低于95％，扣1分
          </div>
          <template #reference>
            <img src="@/assets/appraise/ic_appraise_help.png" class="size-12 object-scale-down" />
          </template>
        </van-popover>

      </div>
      <div class="card-bg">
        <div class="flex-col ">
          <div class="" v-if="detail.deductionReason">扣分原因：{{ detail.deductionReason }}
          </div>
          <div v-else class="mx-auto my-0 w-full flex justify-center items-center">
            暂无数据
          </div>
        </div>
      </div>
      <!--投诉办结情况-->
      <!-- dev-1.2.0关闭 -->
      <div class="main">
        <div class="title">投诉办结情况</div>
        <div class="content">
          <div style="height:220px;">
            <pieCharts :pieData="pieList" :pieRatio="pieRatio"></pieCharts>
          </div>
          <div class="tongji line_top mt015">
            <div class="tj-item line_right">
              <div class="name">投诉总件数</div>
              <div class="num">
                {{detail.doneNum}}
                <span>件</span>
              </div>
            </div>
            <div class="tj-item line_right">
              <div class="name">24小时内办结数量</div>
              <div class="num">
                {{detail.doneinNum}}
                <span>件</span>
              </div>
            </div>
            <div class="tj-item ">
              <div class="name">24小时内未办结数量</div>
              <div class="num">
                {{detail.doneoutNum}}
                <span>件</span>
              </div>
            </div>
            
          </div>
          <div class="ts-list line_top" @click="navToComplain">
            查看投诉件列表
            <img class="img" src="@/assets/image/t-right.png" />
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
// import Vue from 'vue';
import causeDeduction from "../../components/causeDeduction"; // 扣分原因
import casePublicity from "../../components/casePublicity"; // 涉旅案件公示
import materialScience from "../../components/materialScience"; // 相关材料
import causeDetail from "../../components/causeDetail"; // 扣分详情 企业详情
import pieCharts from "../../components/PieCharts"; // 环形进度
import negativeDetail from "../../components/negativeDetail"; // 舆情详情
import txtTag from "../../components/txt-tag";
import RankChartsRate from "../../components/RankChartsRate"; // 进度
import api from "../../../../service/modules/appraiseNew";
import apimessage from "../../../../service/modules/message";
import apicomplaint from "../../../../service/modules/complaint";
import util from "../../../../utils/common";
import { type } from "os";
// Vue.use(Picker);
export default {
  components: {
    causeDeduction,
    casePublicity,
    materialScience,
    pieCharts,
    negativeDetail,
    txtTag,
    causeDetail,
    RankChartsRate
  },

  data() {
    return {
      showPopover:false,
      detail: {},
      // 饼图
      pieList: [],
      rankList: [
        { id: 1, city: "餐饮", mark: "93.23", change: 1, changeRank: 2 },
        { id: 2, city: "住宿", mark: "80.00", change: 2, changeRank: 2 },
        { id: 3, city: "旅行社", mark: "72.30", change: 1, changeRank: 2 },
        { id: 4, city: "租赁车", mark: "60.00", change: 2, changeRank: 2 },
        { id: 5, city: "旅行汽车", mark: "50.00", change: 0, changeRank: 2 }
      ],
      areaType: 1,
      subName: "",
      assessDetail: {},
      subType: "A1",
      row: {},
      isDescStatus: false,
      compDoneInfo: {},
      // 饼图
      // 涉旅案件公示列表
      tripCaseList: [],
      // 相关材料列表
      assessTitle: "相关材料",
      assessFile: [],
      integPreceptFile: [],
      integContraFile: [],
      integGistFile: [],
      // 扣分原因
      deductionReason: "",
      complainDetailUrlInfo: {},
      caseDetail: "",
      deducDetail: "",
      // 投诉件详情
      detailList: [],
      // 企业信息
      infoList: [
        {
          name: "企业名称",
          value: "云南洲途国际旅行社有限公司"
        },
        {
          name: "企业地址",
          value: "昆明市官渡区北京路锦华国际酒店14楼"
        },
        {
          name: "政府评价分",
          value: "100分"
        },
        {
          name: "专业评价分",
          value: "100分"
        }
      ],
      opinionInfo: {},
      complainInfo: "",
      urlParams: {},
      urlParams2: {},
      complainQuarter: "",
      stype: "",
      isShow: false,
      pieRatio: "0",
      integrityDoneRate: {},
      quarterName: this.$route.query.quarterName,
      pageType: this.$route.query.pageType,
      isExceed: this.$route.query.isExceed
    };
  },
  methods: {
    async getComplainDealById() {
      const { id } = this.$route.query;
      let res = await api.getComplainDealById({ id: id });
      if (res.ret === 0) {
        this.detail = res.data;
        this.pieRatio = res.data.doneNum == '0' ? '0' : (res.data.doneinNum*100 / res.data.doneNum).toFixed(2);
        console.log('-----饼图数据：', this.pieRatio);
        this.pieList = [
          
          {
            value: 100 - this.pieRatio,
            name: "超24小时办结数量"
          },
          {
            value: this.pieRatio,
            name: "24小时内办结数量"
          }
        ];
      }
    },
    toComplaintDetails() {
      // if (this.subType == '5fzwxy') {
      //     this.stype = 'notRespondDetail'
      // } else {
      this.stype = "notFinishedDetail";
      // }
      this.urlParams2 = {
        year: this.complainQuarter.year,
        quarter: this.complainQuarter.quarter,
        type: this.stype,
        cityId: this.complainQuarter.cityId
      };
      sessionStorage.setItem("urlInfo", JSON.stringify(this.urlParams2)); // 参数
      this.$router.push({
        path: "/appraise/complainList" // 跳转到投诉件详情
      });
    },
    // 查投诉详情信息跳转到投诉详细界面
    navToComplain() {
      // const { year, quarter, areaName} = this.$route.query;
      // this.$router.push(`/appraise/scoreLists?cityId=${this.detail.cityId}&year=${year}&quarter=${quarter}`)
      
      // this.$router.push(`/complaint/checkList?type=satisfiedList&areaOne=${this.detail.cityId}&fullAdress=${areaName}&year=${year}&quarter=${quarter}`);
      window.yyn.invokeJSB(
          "openWindow",
          {
            openUrl: `yyngov://complaint?path=complaint_inbox_list`,
            isFullScreen: 1,
            setTitle: "",
            needLoading: 1
          },
          cb => {
            console.log(cb, "callback");
          })
    },
    // 查询列表
    getList() {
      const data = {
        curPage: 1,
        pageSize: 10,
        type: this.complainDetailUrlInfo.urlParams.type,
        inputParams: this.row.mainComplainId
      };

      apicomplaint.assessToComplain(data).then(res => {
        util.setJsonLocal("item", res.data.list[0]);
        this.$store.commit("complaint/getItemList", res.data.list[0]);
        // this.$router.push(`/complaint/detailListAssess/complaintSheetAssess`)
        window.yyn.invokeJSB(
          "openWindow",
          {
            openUrl: `${
              this.globalApp.getSystemInfo().host
            }web/#/complaint/detailListAssess/complaintSheetAssess`,
            isFullScreen: 0,
            setTitle: "",
            needLoading: 1
          },
          cb => {
            console.log(cb, "callback");
          }
        );
      });
    },
    showmoreDesc(e) {
      let el = e.currentTarget;
      el.previousElementSibling.classList[
        !this.isDescStatus ? "add" : "remove"
      ]("hide");
      // el.classList[this.isDescStatus ? 'add' : 'remove']('more-collapse');
      // el.innerHTML = !this.isDescStatus ? '展开' : '收起';
      this.isDescStatus = !this.isDescStatus;
      this.isShowMore = true;
    },
    // 消息单条已读
    onMessageReadOne(isRead, id) {
      if (isRead === "false") {
        apimessage.messageReadOne({ messageId: id }).then(res => {
          localStorage.setItem("messageId", id);
        });
      }
    }
  },

  mounted() {},

  created() {
    this.getComplainDealById();
  }
};
</script>
<style scoped lang="less">
@vv: 3.75vw;
.card-bg {
  background-color: #fff;
  padding-top: 16px;
  padding-bottom: 16px;
  box-shadow: 0px 0px 10px 0px rgba(0, 0, 0, 0.04);
  border-radius: 3px;
  padding-left: 12px;
  padding-right: 12px;
}
.container {
  min-height: 100vh;
  background: rgba(251, 251, 251, 1);
  padding-bottom: 24px;

  .pg-pd12 {
    padding-left: 12px;
    padding-right: 12px;
  }

  .complain {
    position: relative;
    line-height: 46px;
    background: rgba(255, 255, 255, 1);
    box-shadow: 0px 0px 10px 0px rgba(0, 0, 0, 0.04);
    border-radius: 3px;
    padding: 0 16px;
    margin-top: 24px;
    font-size: 16px;
    font-family: PingFangSC-Medium, PingFang SC;
    font-weight: bold;
    color: rgba(51, 51, 51, 1);
  }
  .complain::after {
    content: "";
    position: absolute;
    right: 16px;
    top: 16px;
    width: 12px;
    height: 12px;
    background: url("../../../../assets/image/t-right.png") no-repeat;
    background-size: 12px 12px;
  }

  .head {
    width: 100%;
    background: #fff;
    padding: 23px 12px 12px 12px;

    .title {
      line-height: 22px;
      display: flex;
      justify-content: space-between;

      .text {
        font-size: 20px;
        font-family: PingFangSC-Medium, PingFang SC;
        font-weight: bold;
        color: rgba(51, 51, 51, 1);
        line-height: 28px;
        padding-right: 32px;
      }

      .branch {
        height: 22px;
        font-size: 22px;
        font-family: DIN-Medium, DIN;
        font-weight: 500;
        color: rgba(255, 77, 77, 1);
        line-height: 28px;
      }
      .no-de {
        font-size: 20px;
        font-family: PingFangSC-Medium, PingFang SC;
        font-weight: bold;
        color: rgba(54, 179, 116, 1);
        line-height: 22px;
      }
    }
    .tag-box {
      width: 120%;
      height: 28px;
      display: flex;
      align-items: center;
      margin-top: 10px;
      transform: scale(0.5);
      transform-origin: left 0;
    }
    .date {
      margin-bottom: 12px;
      font-size: 12px;
      font-family: PingFangSC-Regular, PingFang SC;
      font-weight: 400;
      color: rgba(153, 153, 153, 1);
      line-height: 12px;
    }
  }
  .main {
    margin-top: 24px;

    .title {
      font-size: 16px;
      font-family: PingFangSC-Medium, PingFang SC;
      font-weight: bold;
      color: rgba(51, 51, 51, 1);
    }

    .content {
      background: rgba(255, 255, 255, 1);
      box-shadow: 0px 0px 10px 0px rgba(0, 0, 0, 0.04);
      border-radius: 3px;
      margin-top: 12px;
      .pro-mr {
        margin-top: 24px;
        padding: 12px;
      }
      .tongji {
        display: flex;
        align-items: center;

        .tj-item {
          display: flex;
          flex-direction: column;
          justify-content: center;
          flex: 1;
          padding: 16px 0;
          text-align: center;

          .name {
            font-size: 12px;
            font-family: PingFangSC-Regular, PingFang SC;
            font-weight: 400;
            color: rgba(51, 51, 51, 1);
          }

          .num {
            font-size: 20px;
            font-family: DIN-Bold, DIN;
            font-weight: bold;
            color: rgba(54, 179, 116, 1);
            margin-top: 8px;
            vertical-align: top;
            display: inline-block;
            text-align: center;
            position: relative;

            span {
              font-size: 10px;
              padding-left: 4px;
              font-weight: normal;
              position: absolute;
              display: inline-block;
              font-weight: normal;
              bottom: 2px;
            }
          }
        }
      }
      .mt015 {
        margin-top: -15px;
      }

      .ts-list {
        width: 100%;
        font-size: 12px;
        font-family: PingFangSC-Regular, PingFang SC;
        font-weight: 400;
        color: rgba(155, 155, 155, 1);
        position: relative;
        vertical-align: top;
        display: inline-block;
        text-align: center;
        line-height: 41px;
        .img {
          position: absolute;
          display: inline-block;
          width: 10px;
          height: 10px;
          top: 50%;
          transform: translateY(-50.5%);
          img {
            width: 100%;
          }
        }
      }
    }
  }
  .right-five-txt{
    position: relative;
  }
  .txtDec{
    text-decoration: line-through;
  }
  .timememo {
    color: #ff8c19;
    font-size: 12px;
    font-family: PingFangSC-Medium, PingFang SC;
    font-weight: 500;
    // text-align: right;
    width: 100px;
    margin-top: 6px;
    position: absolute;
    right: -30px;
  }
}
</style>
